import { create } from "zustand";
import api from "../api/axios";

const useEmployeeStore = create((set) => ({
  employeeData: [],
  loading: false,
  error: null,

  fetchEmployees: async ({ selectedCompany, permissions }) => {
    try {
      const totalStart = performance.now();

      set({
        loading: true,
        error: null,
      });

      const timestamp = Date.now();

      const hasViewPerGroupPermission = permissions.some(
        (permission) => permission.name === "view_per_group_all_employees_info",
      );

      const hasViewAllManagedPermission = permissions.some(
        (permission) => permission.name === "view_all_managed_employees_info",
      );

      let apiUrl = "";

      if (hasViewPerGroupPermission) {
        apiUrl = `/employees/employeeInformation?company=${selectedCompany}&timestamp=${timestamp}`;
      } else if (hasViewAllManagedPermission) {
        apiUrl = `/employees/employeesDataForManagers?timestamp=${timestamp}`;
      } else {
        set({
          employeeData: [],
          loading: false,
        });

        return [];
      }

      // API timing
      const apiStart = performance.now();

      const response = await api.get(apiUrl);

      console.log("Records:", response.data?.data?.length);

      console.log(
        "Response Size:",
        JSON.stringify(response.data).length / 1024,
        "KB",
      );

      const apiEnd = performance.now();

      console.log(`API Response Time: ${(apiEnd - apiStart).toFixed(2)} ms`);

      // Processing timing
      const processStart = performance.now();

      const data = response.data?.data || [];
      const employees = data.flatMap((item) => item.users);

      const processEnd = performance.now();

      console.log(
        `Frontend Processing Time: ${(processEnd - processStart).toFixed(2)} ms`,
      );

      set({
        employeeData: employees,
        loading: false,
      });

      const totalEnd = performance.now();

      console.log(`Total Time: ${(totalEnd - totalStart).toFixed(2)} ms`);

      return employees;
    } catch (error) {
      console.log(error);

      set({
        employeeData: [],
        loading: false,
        error,
      });

      return [];
    }
  },

  clearEmployees: () => {
    set({
      employeeData: [],
      error: null,
    });
  },
}));

export default useEmployeeStore;
